import { Component, OnInit } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { trigger, transition, style, animate, query, stagger } from '@angular/animations';


@Component({
    selector: 'app-hometwo-banner',
    templateUrl: './hometwo-banner.component.html',
    styleUrls: ['./hometwo-banner.component.scss'],
})
export class HometwoBannerComponent implements OnInit {

    constructor() { }

    ngOnInit(): void {
    }

//     mainBannerItem = [
//     {
//         title: 'Taste the ',
//         title2:'Tradition of India',
//         tagline: 'Union Fire Production',
//         subtitle: 'Safety You Can Trust',
//         paragraph: 'We provide reliable fire safety solutions designed to protect industries, buildings, and people from fire risks.',
//         buttonText: 'EXPLORE SOLUTIONS',
//         buttonLink: '/services',
//         image: 'assets/img/slider/slide1.jpg',
//         overlayColor: 'rgba(120, 20, 20, 0.7)',
        
//     },
//     {
//         title: 'Authentic Flavours from ',
//         title2:' Every Indian Kitchen',
//         tagline: 'Built for High-Risk Environments',
//         subtitle: 'Engineered for Protection',
//         paragraph: 'Our fire systems are designed for factories, warehouses, and production units to ensure maximum safety.',
//         buttonText: 'VIEW SYSTEMS',
//         buttonLink: '/services',
//         image: 'assets/img/slider/slide2.jpg',
//         overlayColor: 'rgba(90, 30, 30, 0.7)',
      
//     },
//     {
//         title: 'Where Recipes ',
//         title2:'Tell Stories',
//         tagline: 'Strong. Safe. Reliable.',
//         subtitle: 'Protection That Lasts',
//         paragraph: 'We deliver high-quality fire-resistant materials and solutions built to withstand extreme conditions.',
//         buttonText: 'SEE PRODUCTS',
//         buttonLink: '/products',
//         image: 'assets/img/slider/slide3.jpg',
//         overlayColor: 'rgba(80, 25, 25, 0.7)',
      
//     },
//     {
//         title: 'Serving India on ',
//         title2:'Every Plate',
//         tagline: 'Prepared for Every Situation',
//         subtitle: 'Fast Response Technology',
//         paragraph: 'Our advanced systems detect and control fire hazards quickly, helping reduce damage and risk.',
//         buttonText: 'LEARN MORE',
//         buttonLink: '/services',
//         image: 'assets/img/slider/slide4.jpg',
//         overlayColor: 'rgba(100, 20, 20, 0.7)',
      
//     },
//     {
//         title: 'From Our Kitchen to ',
//         title2:'Your Heart',
//         tagline: 'Quality You Can Depend On',
//         subtitle: 'Tested & Approved',
//         paragraph: 'All our solutions meet strict safety standards, ensuring reliable performance in critical situations.',
//         buttonText: 'VIEW CERTIFICATIONS',
//         buttonLink: '/about',
//         image: 'assets/img/slider/slide5.jpg',
//         overlayColor: 'rgba(70, 20, 20, 0.7)',

//     },
   
// ];

mainBannerItem = [
    {
        title: 'Where Little ',
        title2:'Dreams Begin',
        tagline: 'Premium Toys Collection',
        subtitle: 'Play. Learn. Grow.',
        paragraph: 'Discover beautifully crafted toys that inspire imagination, creativity, and joyful childhood memories.',
        buttonText: 'SHOP COLLECTION',
        buttonLink: '/shop',
        image: 'assets/img/slider/5.1.png',
        overlayColor: 'rgba(91, 140, 255, 0.45)',
    },
    {
        title: 'Endless Fun for ',
        title2:'Every Little Explorer',
        tagline: 'Creative Learning Toys',
        subtitle: 'Designed for Happy Childhoods',
        paragraph: 'From educational games to playful adventures, explore toys made to spark curiosity and creativity.',
        buttonText: 'EXPLORE TOYS',
        buttonLink: '/shop',
        image: 'assets/img/slider/4.png',
        overlayColor: 'rgba(123, 97, 255, 0.45)',
    },
    // {
    //     title: 'Magical Toys ',
    //     title2:'Made with Love',
    //     tagline: 'Safe & Premium Quality',
    //     subtitle: 'Crafted for Smiles',
    //     paragraph: 'Our carefully selected toys are designed with safety, quality, and endless fun in mind.',
    //     buttonText: 'VIEW COLLECTION',
    //     buttonLink: '/products',
    //     image: 'assets/img/slider/slide3.jpg',
    //     overlayColor: 'rgba(255, 122, 24, 0.45)',
    // },
    // {
    //     title: 'Bring Home ',
    //     title2:'The Joy of Play',
    //     tagline: 'Fun for Every Age',
    //     subtitle: 'Imagination Starts Here',
    //     paragraph: 'Explore exciting toys, games, and creative playsets loved by kids and trusted by parents.',
    //     buttonText: 'DISCOVER MORE',
    //     buttonLink: '/shop',
    //     image: 'assets/img/slider/slide4.jpg',
    //     overlayColor: 'rgba(255, 61, 129, 0.40)',
    // },
    // {
    //     title: 'Creating Happy ',
    //     title2:'Childhood Memories',
    //     tagline: 'Trusted Toy Store',
    //     subtitle: 'Playtime Reimagined',
    //     paragraph: 'From cuddly companions to exciting adventures, find premium toys that make every moment special.',
    //     buttonText: 'SHOP NOW',
    //     buttonLink: '/about',
    //     image: 'assets/img/slider/slide5.jpg',
    //     overlayColor: 'rgba(91, 140, 255, 0.40)',
    // },
];
    

    homeSlidesOptions: OwlOptions = {
        loop: true,
        nav: true,
        margin: 0,
        dots: true,
        autoplay: true,
        autoplayTimeout: 5000,
        autoHeight: true,
        animateIn: 'fadeIn',
        animateOut: 'fadeOut',
        autoplayHoverPause: true,
        navText: [
            "<i class='bx bx-chevron-left'></i>",
            "<i class='bx bx-chevron-right'></i>"
        ],
        responsive: {
            0: { items: 1 },
            576: { items: 1 },
            768: { items: 1 },
            992: { items: 1 },
            1200: { items: 1 }
        }
    }

}
